// extracted by mini-css-extract-plugin
module.exports = {"sideRailArticles":"SideRailArticles_sideRailArticles__K9eXx","sideRailArticles__article":"SideRailArticles_sideRailArticles__article__oSjOS"};